import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CachedQuickApplyParameters } from "./getCachedQuickApplyParameters";

export interface SaveCachedQuickApplyParametersOverrideResponse
  extends BackendResponse {}

export interface SaveCachedQuickApplyParametersOverrideParameters
  extends NextApiParams {
  parameters: CachedQuickApplyParameters;
}

export const saveCachedQuickApplyParametersOverride = withNextApi<
  SaveCachedQuickApplyParametersOverrideResponse,
  SaveCachedQuickApplyParametersOverrideParameters
>("/auth/SaveCachedQuickApplyParametersOverride", { method: "POST" });
